// extracted by mini-css-extract-plugin
export var Faqs = "FaqSection-mps-module--Faqs--97686";
export var accordionContentCustom = "FaqSection-mps-module--accordionContentCustom--b22f6";
export var accordionHeaderRootCustom = "FaqSection-mps-module--accordionHeaderRootCustom--d1277";
export var accordionTitleCustom = "FaqSection-mps-module--accordionTitleCustom--37e65";
export var colDetails = "FaqSection-mps-module--colDetails--1bee7";
export var iconContainerCustom = "FaqSection-mps-module--iconContainerCustom--fdbd5";